<section class="mobileInstructions" *ngIf="!displaySafariContent">
    <div class="backgroundImage"  [cache]="backgroundImage" [lazyload]="backgroundImage"  role="presentation" alt="" tabindex="-1">
        <div class="description">
            <img  [cache]="csp.imagePrefix() + content?.citishopLogoPath" [lazyload]="csp.imagePrefix() + content?.citishopLogoPath"
            role="presentation" alt="" tabindex="-1">
            <p *ngIf="displayChromeMsg" class="mobileInstructions__text" [innerHTML]="content?.chrome | safeHtml"></p>
            <p *ngIf="!displayChromeMsg" class="mobileInstructions__text" [innerHTML]="content?.edgeAndSafari | safeHtml"></p>
            <button type="button" cdsButton="primary" cdsButton (click)="copyEnrollmentLink()" *ngIf="displayEnrollmentBtn">
                {{content?.btnCopyEnrollmentLinkText}}
            </button>
        </div>
    </div>
</section>
<section class="mobileInstructions-safari" *ngIf="displaySafariContent">
    <div>
        <div class="logo-container">
            <img [ngSrc]="csp.imagePrefix() + content?.citishopLogoPath" role="presentation" alt="" aria-hidden="true"
                tabindex="-1" width="106" height="34">
        </div>
        <h1 [innerHtml]="iOSSafariContent?.heading | safeHtml"></h1>
        <p class="instruction" (click)="ctaInteraction($event)" [innerHtml]="iOSSafariContent?.instruction | safeHtml"></p>
        <div class="img-install-container">
            <img [src]="csp.imagePrefix() + instructionsImg" [alt]="iOSSafariContent?.instructionGif?.adaText || ''"
                [height]="'280'" [width]="'260'">
            <img [src]="csp.imagePrefix() + playButtonImg" [alt]="iOSSafariContent?.stopIcon?.adaText || ''" aria-hidden="true"
                [height]="'26'" [width]="'80'" class="icon" (click)="playInteraction()" role="button">

            <div class="instruction-steps">
                <ul>
                    @for(item of iOSSafariContent?.listSteps;track $index){
                    <li role='button' (click)="highlightSteps($event, $index + 1)">
                        <span class='active-circle' id="li-cirlce-{{$index + 1}}">{{$index + 1}}</span>
                        <li-text [innerHTML]="item | safeHtml"></li-text>
                    </li>
                    }

                </ul>
            </div>
            <div class="footerInstructions" (click)="ctaInteraction($event)" [innerHtml]="iOSSafariContent?.footerInstructions | safeHtml"></div>
        </div>
    </div>
</section>
